module.exports = __webpack_public_path__ + "fb.png?bda86a311ffc7c4e5311096f161b8c13";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fb.png
// module id = 71
// module chunks = 0